"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSchema_1 = require("./JSchema/JSchema");
exports.JSchema = JSchema_1.default;
var schemaMixin_1 = require("./schemaMixin");
exports.schemaMixin = schemaMixin_1.default;
var schemaMethods_1 = require("./schemaMethods");
exports.schemaMethods = schemaMethods_1.default;
// tslint:disable-next-line: no-var-requires
// const polyfills = require('./polyfills.ts');
var polyfills = require("./polyfills");
exports.polyfills = polyfills;
var WrappedProperty_1 = require("./WrappedProperty");
exports.WrappedPropertyCtor = WrappedProperty_1.default;
exports.wrap = WrappedProperty_1.wrap;
var fixAndMergeSchema_1 = require("./JSchema/fixAndMergeSchema");
exports.fixAndMergeSchema = fixAndMergeSchema_1.default;
exports.default = JSchema_1.default;
//# sourceMappingURL=index.js.map